/**
 * Base Controller
 *
 * Extends Stimulus Controller with shared utility methods.
 * All application controllers should extend this class.
 */

import { Controller } from "/js/vendor/stimulus.js";
import { escapeHtml } from "../utils/html.js";
import { formatDate, formatShortDate, formatMonthYear, formatTimeAgo, formatRelativeDate } from "../utils/format.js";
import { isValidEmail } from "../utils/validation.js";
import { getPagesToShow } from "../utils/pagination.js";
import { cloneTemplate, fillSlots, fillHtmlSlots } from "../utils/template.js";
import confirm from "../services/confirm.js";
import toast from "../services/toast.js";

export default class BaseController extends Controller {
  // ---------------------------------------------------------------------------
  // State management
  // ---------------------------------------------------------------------------

  showLoadingState() {
    if (this.hasLoadingStateTarget) this.loadingStateTarget.style.display = "block";
    if (this.hasErrorStateTarget) this.errorStateTarget.style.display = "none";
    if (this.hasContentStateTarget) this.contentStateTarget.style.display = "none";
  }

  showErrorState() {
    if (this.hasLoadingStateTarget) this.loadingStateTarget.style.display = "none";
    if (this.hasErrorStateTarget) this.errorStateTarget.style.display = "block";
    if (this.hasContentStateTarget) this.contentStateTarget.style.display = "none";
  }

  showContentState() {
    if (this.hasLoadingStateTarget) this.loadingStateTarget.style.display = "none";
    if (this.hasErrorStateTarget) this.errorStateTarget.style.display = "none";
    if (this.hasContentStateTarget) this.contentStateTarget.style.display = "block";
  }

  // ---------------------------------------------------------------------------
  // Toast notifications
  // ---------------------------------------------------------------------------

  showError(message) {
    toast.error(message);
  }

  showSuccess(message) {
    toast.success(message);
  }

  // ---------------------------------------------------------------------------
  // Utility methods
  // ---------------------------------------------------------------------------

  escapeHtml(text) {
    return escapeHtml(text);
  }

  formatDate(dateString, options = {}) {
    return formatDate(dateString, options);
  }

  formatShortDate(dateString, options = {}) {
    return formatShortDate(dateString, options);
  }

  formatMonthYear(dateString, options = {}) {
    return formatMonthYear(dateString, options);
  }

  formatTimeAgo(dateString) {
    return formatTimeAgo(dateString);
  }

  formatRelativeDate(dateString) {
    return formatRelativeDate(dateString);
  }

  isValidEmail(email) {
    return isValidEmail(email);
  }

  getPagesToShow(current, total) {
    return getPagesToShow(current, total);
  }

  cloneTemplate(id) {
    return cloneTemplate(id);
  }

  fillSlots(fragment, data) {
    return fillSlots(fragment, data);
  }

  fillHtmlSlots(fragment, data) {
    return fillHtmlSlots(fragment, data);
  }

  confirm(message, options) {
    return confirm(message, options);
  }
}
